import { __decorate } from "tslib";
import Reportable from '../decorators/reportable';
import * as CONST from '../const';
class UIUploader {
    owner;
    project;
    imageDataURL = '';
    imageInfo = {};
    imageItem;
    uploaded = false;
    container;
    files = new Map();
    constructor(owner, project) {
        this.owner = owner;
        this.project = project;
    }
    createImgFromFilename(filename) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                resolve(img);
            };
            img.src = `${CONST.UPLOAD_PATH_WEB}${filename}`;
            img.onerror = reject;
        });
    }
    createHeicReader(file, uploaderItem) {
        console.log('HEIC reader needed', file);
        // convert "fetch" the new blob url
        uploaderItem.renderThumbnail(`${CONST.UPLOAD_PATH_WEB}${file.name}`);
        this.onImageSelect(uploaderItem.html.get(0));
        setTimeout(function () {
            uploaderItem.html.find('.progress-bar2').fadeOut(400);
        }, 400);
    }
    render(container) {
        this.container = container;
        const that = this;
        $(document.body).on('click', '.fileuploader-item', this.onImageSelectEvent.bind(this));
        $(this.getContainerElement()).find(`.${CONST.FILE_UPLOADER_INPUT_CLASS}`).fileuploader({
            enableApi: true,
            limit: 15,
            maxSize: 100,
            extensions: ['jpg', 'jpeg', 'png', 'pdf', 'tiff', 'jfif', 'heic'],
            changeInput: `<div class="fileuploader-input">
								<div class="fileuploader-input-inner">
									<div class="fileuploader-input-button"><span>Загрузите фото</span></div>
								</div>
							</div>`,
            theme: 'default',
            thumbnails: {
                useObjectUrl: true,
                popup: {
                    container: 'body',
                    arrows: true,
                    loop: true,
                    onShow: function (item) {
                        document.body.style.overflowY = 'hidden';
                        item.popup.html.on('click', '[data-action="cancel"]', function () {
                            item.popup.close();
                            document.body.style.overflowY = 'scroll';
                        }).on('click', '[data-action="save"]', function () {
                            item.popup.close();
                            document.body.style.overflowY = 'scroll';
                        }).on('click', '[data-action="remove"]', function () {
                            item.popup.close();
                            item.remove();
                            document.body.style.overflowY = 'scroll';
                        });
                    },
                    onHide: null
                },
            },
            upload: {
                url: '/local/vendor/fileuploader/php/ajax_upload_file.php',
                data: null,
                type: 'POST',
                enctype: 'multipart/form-data',
                start: true,
                synchron: true,
                beforeSend: null,
                onSuccess: function (result, item) {
                    let data = {};
                    that.files.set(`${item.id}`, item);
                    item.html.get(0).dataset.id = item.id;
                    try {
                        data = JSON.parse(result);
                    }
                    catch (e) {
                        data.hasWarnings = true;
                    }
                    // if success
                    if (data.isSuccess && data.files[0]) {
                        const file = data.files[0];
                        if (file.old_name.indexOf('.heic') > 0) {
                            that.createHeicReader(file, item);
                        }
                        that.testFile(`${CONST.UPLOAD_PATH_WEB}${file.name}`);
                        that.project.addFiles([{
                                id: item.id,
                                old_name: file.old_name,
                                name: file.name,
                                url: `${CONST.UPLOAD_PATH_WEB}${file.name}`,
                                width: file.width,
                                height: file.height
                            }]);
                        item.name = file.name;
                        item.html.find('.column-title > div:first-child').text(file.name).attr('title', file.name);
                    }
                    // if warnings
                    if (data.hasWarnings) {
                        for (const warning in data.warnings) {
                            alert(warning);
                        }
                        item.html.removeClass('upload-successful').addClass('upload-failed');
                        return this.onError ? this.onError(item) : null;
                    }
                    //item.html.find('.column-actions')
                    //  .append('<a class="fileuploader-action fileuploader-action-remove fileuploader-action-success" title="Удалить"><i></i></a>');
                    that.onImageSelect(item.html.get(0));
                    setTimeout(function () {
                        item.html.find('.progress-bar2').fadeOut(400);
                    }, 400);
                    that.uploaded = true;
                },
                onError: function (item) {
                    const progressBar = item.html.find('.progress-bar2');
                    if (progressBar.length > 0) {
                        progressBar.find('span').html(0 + "%");
                        progressBar.find('.fileuploader-progressbar .bar').width(0 + "%");
                        item.html.find('.progress-bar2').fadeOut(400);
                    }
                    item.upload.status != 'cancelled' && item.html.find('.fileuploader-action-retry').length == 0 ? item.html.find('.column-actions').prepend('<a class="fileuploader-action fileuploader-action-retry" title="Retry"><i></i></a>') : null;
                },
                onProgress: function (data, item) {
                    const progressBar = item.html.find('.progress-bar2');
                    if (progressBar.length > 0) {
                        progressBar.show();
                        progressBar.find('span').html(data.percentage + "%");
                        progressBar.find('.fileuploader-progressbar .bar').width(data.percentage + "%");
                    }
                },
                onComplete: null,
            },
            onRemove: function (item) {
                $.post('/local/vendor/fileuploader/php/ajax_remove_file.php', {
                    file: item.name
                });
                that.project.removeFiles([item.id]);
            },
            onFileRead: function (d, l, p, o, s) {
                console.log(d, l, p, o, s);
            },
            captions: {
                button: function (options) {
                    return 'Choose ' + (options.limit == 1 ? 'File' : 'Files');
                },
                feedback: function (options) {
                    return 'Choose ' + (options.limit == 1 ? 'file' : 'files') + ' to upload';
                },
                feedback2: function (options) {
                    return options.length + ' ' + (options.length > 1 ? ' files were' : ' file was') + ' chosen';
                },
                confirm: 'Сохранить',
                cancel: 'Отмена',
                name: 'Название',
                type: 'Тип',
                size: 'Размер',
                dimensions: 'Размерности',
                duration: 'Длительность',
                crop: 'Обрезать',
                rotate: 'Повернуть',
                sort: 'Сортировка',
                download: 'Скачать',
                remove: 'Удалить',
                drop: 'Перетащите файлы для загрузки',
                paste: '<div class="fileuploader-pending-loader"></div> Pasting a file, click here to cancel.',
                removeConfirmation: 'Вы действительно хотите удалить эти файлы?',
                errors: {
                    filesLimit: 'Only ${limit} files are allowed to be uploaded.',
                    filesType: 'Only ${extensions} files are allowed to be uploaded.',
                    fileSize: '${name} is too large! Please choose a file up to ${fileMaxSize}MB.',
                    filesSizeAll: 'Files that you chose are too large! Please upload files up to ${maxSize} MB.',
                    fileName: 'File with the name ${name} is already selected.',
                    folderUpload: 'You are not allowed to upload folders.'
                }
            }
        });
    }
    onImageSelectEvent(e) {
        const el = e.currentTarget;
        this.onImageSelect(el);
    }
    async onImageSelect(el) {
        const id = el.dataset.id, item = id ? this.files.get(id) : false;
        if (!item) {
            return false;
        }
        /*
      if (this.imageItem && (this.imageItem.id === item.id)) {
        return;
      }
      */
        if (!item.reader.node && item.extension !== 'heic') {
            setTimeout(this.onImageSelect.bind(this, el), 100);
            return;
        }
        if (item.extension === 'heic') {
            item.reader = await this.createImgFromFilename(item.name);
        }
        this.imageInfo = {
            width: item.reader.width,
            height: item.reader.height,
            ratio: item.reader.width / item.reader.height
        };
        const ratio = this.imageInfo.ratio;
        this.imageItem = item;
        const canvas = document.createElement('canvas');
        canvas.width = ratio > 1 ? CONST.BASE_SIZE_FOR_PREVIEW : CONST.BASE_SIZE_FOR_PREVIEW * ratio;
        canvas.height = ratio > 1 ? CONST.BASE_SIZE_FOR_PREVIEW / ratio : CONST.BASE_SIZE_FOR_PREVIEW;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.drawImage(item.reader.node || item.reader, 0, 0, canvas.width, canvas.height);
            this.imageDataURL = canvas.toDataURL('image/jpg', 0.9);
            this.project.setImageFileId(item.id);
            this.project.changeImage(this.imageDataURL);
        }
        return false;
    }
    getContainerElement() {
        if (this.container) {
            return this.container;
        }
        throw new Error('No main container in fileuploader');
    }
    setUploaded() {
        this.uploaded = true;
    }
    isUploaded() {
        return this.uploaded;
    }
    async testFile(url) {
        const res = await fetch(url, { method: 'HEAD' });
        if (!res.ok) {
            throw new Error('Uploaded image doesnt exists.');
        }
    }
}
__decorate([
    Reportable
], UIUploader.prototype, "render", null);
__decorate([
    Reportable
], UIUploader.prototype, "onImageSelectEvent", null);
__decorate([
    Reportable
], UIUploader.prototype, "onImageSelect", null);
__decorate([
    Reportable
], UIUploader.prototype, "getContainerElement", null);
__decorate([
    Reportable
], UIUploader.prototype, "testFile", null);
export default UIUploader;
